export default __webpack_public_path__ + "static/media/water_drop.21b9ebec.svg";